module.exports = __webpack_public_path__ + "static/media/physio.a6b45bfc.jpg";